<template>
  <div
    class="home-section d-flex flex-column flex-md-row"
  >
    <div class="main-text">
      <h1 class="main-title">
        私服123
      </h1>
      <h2 class="sub-title">
        私服遊戲推廣平台
      </h2>
      <a
        class="btn"
        href="/lineage.html"
      >
        開始使用
      </a>
    </div>
    <div
      class="game"
    >
      <div
        v-for="game,index in gameList"
        :key="index"
        class="game-marquee"
      >
        <ul
          class="marquee marquee-first"
        >
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
        </ul>
        <ul
          class="marquee marquee-second"
        >
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
          <li>{{ game }}</li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
// import {
//   BImg,
// } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
// import Parallax from 'parallax-js'
import store from '@/store'
// import router from '@/router'

export default {
  metaInfo: {
    title: '首頁',
    titleTemplate: `%s - ${store.state.app.titleTemplate}`,
  },
  components: {
    // BImg,
  },
  data() {
    return {
      gameList: [
        '天堂',
        'RO仙境傳說',
        '楓之谷',
        '墨香',
        '希望',
        '楓之谷M',
        'RO',
        '三國群英傳',
      ],
    }
  },
  mounted() {
    // const scene = document.getElementById('scene')
    // // eslint-disable-next-line no-unused-vars
    // const parallaxInstance = new Parallax(scene, {
    //   relativeInput: true,
    // })
  },
  methods: {
    redirectLink() {
      window.location.replace('https://www.gamex123.com/')
    },
  },
  setup() {
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss" scope>
.home-section{
  position: relative;
  height: 100vh;
  width: 100%;
  .game {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 60%;
    overflow: hidden;
    animation: fadein 2s;
    // background: #fff;
    // background: black;
  }
  .mask {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(to right,#ffffffcb, #ffffff00, #ffffffaf);
  }
  .game-marquee {
    position: relative;
    display: flex;
    overflow: hidden;
    height: 80px;
    width: 100%;
    transform: rotate(335deg);
    margin-bottom: 2rem;
    &:hover {
      .marquee {
        li{
          cursor: default;
          color: rgb(255, 238, 0);
        }
      }
    }
    .marquee {
      display: flex;
      padding-left: 0;
      list-style-type: none;
      li {
        white-space: nowrap;
        margin-right: 2em;
        font-weight: bold;
        font-size: 40px;
        line-height: 40px;
        color: rgb(80, 80, 80);
        transition: .2s;
        &:hover {
          cursor: default;
          color: rgb(255, 81, 0);
        }
      }
    }
    .marquee-first {
      animation: marqee 40s linear infinite;
    }
    .marquee-second {
      animation: marqee2 40s linear infinite;
      animation-delay: -20s;
    }
  }
  .main-text{
    position: relative;
    z-index: 20;
    color: #fff;
    background-color: transparent;
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .main-text::after {
    content: "";
    pointer-events: none;
    left: 0;
    position: absolute;
    z-index: 2;
    width: 1000px;
    height: 100%;
    background: linear-gradient(89.39deg,#141414 1.88%,#18181b 52.25%,#0f0f14c7 79.19%,#00000000 96.39%);
    top: 0;
  }
  .main-title {
    position: relative;
    z-index: 3;
    font-size: clamp(5rem, 9vw, 14rem);
    font-weight: 900;
    text-align: center;
    color: #fff;
    text-shadow: 0 0 50px #a5a5a5;
    // color: transparent; /* 文字顏色設定透明 */
    // background-image: linear-gradient(0deg, #020202, #bd5458); /* 設定漸層角度及顏色 */
    // -webkit-background-clip: text; /* 背景裁剪成文字的前景色 */
    // background-clip: text;
  }
  .sub-title {
    position: relative;
    z-index: 3;
    color: #fff;
    font-size: clamp(2.5rem, 5vw, 8rem);
    font-weight: 600;
  }

  .btn {
    position: absolute;
    z-index: 10;
    bottom: 20%;
    display: flex;
    justify-content: center;
    text-align: center;

    padding:12px 30px;
    border-radius: 10px;
    color:#fff;
    background-color:#4683bb;
    box-shadow:0 5px 20px #b8c2cc88;
    font-size: 16px;
    transform: scale(1.05);
    transition: .1s;
  }
  .btn:hover {
    box-shadow: 0px 0px 25px #00cfe8;
  }
  .btn:active {
    transform: scale(1);
    box-shadow: 0px 0px 25px #00cfe8;
  }
}

@media only screen and (max-width: 1200px){
  .home-section{
    .main-text::after {
      width: 700px;
    }
  }

}
@media only screen and (max-width: 768px){
  .home-section{
    height: 100%;
    .game {
      position: absolute;
      top: -90px;
      height: 600px;
      width: 100%;
    }
    .main-text{
      height: 400px;
      width: 100%;
    }
    .main-text::after {
      width: 100%;
      height: 765px;
      background: none;
    }
    .btn {
      bottom: 0;
      margin-bottom: 80px;
    }
  }
}

@keyframes fadein {
  0% { opacity: 0;}
  100% { opacity: 1; }
}
@keyframes marqee {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}
@keyframes marqee2 {
  0% {
    transform: translateX(0%);
  }

  100% {
    transform: translateX(-200%);
  }
}

</style>
